var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscardChanges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-editor---new-admin-bar",
    transform: "translate(-1019.000000, -19.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1025,19 C1023.345,19 1021.8545,19.6765 1020.7705,20.761 L1019.5305,19.521 L1019,23.1915 L1022.7185,22.7085 L1021.474,21.4645 C1022.378,20.5605 1023.6235,20 1025,20 C1027.757,20 1030,22.243 1030,25 C1030,27.757 1027.757,30 1025,30 C1023.064,30 1021.3855,28.892 1020.555,27.2785 L1019.6965,27.8015 C1020.7025,29.703 1022.699,31 1025,31 C1028.3135,31 1031,28.3135 1031,25 C1031,21.6865 1028.3135,19 1025,19 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscardChanges);
export default __webpack_public_path__ + "static/media/icon-discard-changes.972e36a1e2baa1acf6215c9a6d5850e5.svg";
export { ForwardRef as ReactComponent };